var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-shape-issue",class:_vm.holderClasses,on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.logIssue($event)}}},[_c('v-icon',{staticClass:"fill",attrs:{"name":"x"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }